export const FETCH_ERRORS = 'FETCH_ERRORS'

export const SERVER_RESOURCE = '/content/imports/errors'



// WEBPACK FOOTER //
// ./src/pages/imports/errors/constants.ts